module.exports = __webpack_public_path__ + "static/sc_9-5765f9ce70b5ff20979ebcfafc79c599.jpg";